export default [
    { id: 1, name: '支付宝', value: 123 },
    { id: 2, name: '微信', value: 56 },
    { id: 4, name: '其他', value: 10 }
]



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/index/loadCLLXData.js